// extracted by css-extract-rspack-plugin
export default {"orderedList":"content-editor-plugin-ordered-list-OrderedList-orderedList-c0832259"};